(() => {
  function initProductGalleries(root = document) {
    root.querySelectorAll('[data-product-gallery]').forEach(gallery => {
      if (gallery.dataset.carouselReady === 'true') return;

      const viewport = gallery.querySelector('[data-gallery-viewport]');
      const slides = Array.from(gallery.querySelectorAll('[data-gallery-slide]'));
      const previousButton = gallery.querySelector('[data-gallery-prev]');
      const nextButton = gallery.querySelector('[data-gallery-next]');
      const currentLabel = gallery.querySelector('[data-gallery-current]');
      const productSection = gallery.closest('.product-page');
      const variantSelect = productSection?.querySelector('select[name="id"]');

      if (!viewport || slides.length === 0) return;
      gallery.dataset.carouselReady = 'true';

      let currentIndex = 0;
      let animationFrame;
      const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

      function updateCounter() {
        const slideWidth = viewport.clientWidth || 1;
        currentIndex = Math.max(0, Math.min(slides.length - 1, Math.round(viewport.scrollLeft / slideWidth)));
        if (currentLabel) currentLabel.textContent = String(currentIndex + 1);
      }

      function moveTo(index) {
        currentIndex = (index + slides.length) % slides.length;
        const target = slides[currentIndex];
        const left = target.offsetLeft - viewport.offsetLeft;
        viewport.scrollTo({ left, behavior: reduceMotion ? 'auto' : 'smooth' });
        if (currentLabel) currentLabel.textContent = String(currentIndex + 1);
      }

      function moveToVariantMedia(select) {
        const selectedOption = select.options[select.selectedIndex];
        const mediaId = selectedOption?.dataset.featuredMediaId;
        if (!mediaId) return;

        const mediaIndex = slides.findIndex(slide => slide.dataset.galleryMediaId === mediaId);
        if (mediaIndex >= 0) moveTo(mediaIndex);
      }

      previousButton?.addEventListener('click', () => moveTo(currentIndex - 1));
      nextButton?.addEventListener('click', () => moveTo(currentIndex + 1));
      variantSelect?.addEventListener('change', event => moveToVariantMedia(event.currentTarget));

      viewport.addEventListener('scroll', () => {
        window.cancelAnimationFrame(animationFrame);
        animationFrame = window.requestAnimationFrame(updateCounter);
      }, { passive: true });

      viewport.addEventListener('keydown', event => {
        if (event.key === 'ArrowLeft') {
          event.preventDefault();
          moveTo(currentIndex - 1);
        }
        if (event.key === 'ArrowRight') {
          event.preventDefault();
          moveTo(currentIndex + 1);
        }
      });

      window.addEventListener('resize', updateCounter, { passive: true });
      updateCounter();
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initProductGalleries());
  } else {
    initProductGalleries();
  }

  document.addEventListener('shopify:section:load', event => initProductGalleries(event.target));
})();
